<template>
  <a-card :bordered="false" :loading="table.loading">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <a-form-model
            layout="inline"
            label-position="top"
          :model="searchForm.data">
          <a-form-model-item :label="$t('TELEPHONE') || '手机' ">
            <a-input v-model="searchForm.data.phone" allowClear/>
          </a-form-model-item>
          <a-form-model-item :label="'用户Id'">
            <a-input v-model="searchForm.data.userId" allowClear/>
          </a-form-model-item>
          <a-form-model-item :label="$t('OPERATION') || '操作'">
            <a-space>
            <a-button
              type="primary"
              plain
              icon="search"
               @click="searchUser">{{ $t('SEARCH') || '查询' }}
            </a-button>
            </a-space>
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-table
        :scroll="{ y: 'calc(100vh - 405px)' }"
        :data-source="table.data"
        :pagination="table.pagination"
        :loading="table.loading"
        row-key="id"
        @change="handleTableChange"
        style="width: 100%">
        <a-table-column
          data-index="firstName"
          title="姓"
          width="180">
          <template slot-scope="text,record">
            {{ record.firstName }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="lastName"
          title="名"
          width="180">
          <template slot-scope="text,record">
          {{ record.lastName }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="id"
          title="用户Id"
          width="180">
          <template slot-scope="text,record">
            {{ record.id }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="gender"
          :title="$t('GENDER') || '性别'"
          width="180">
          <template slot-scope="text,record">
            {{ record.gender }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="Email"
          title="邮箱"
          width="180">
          <template slot-scope="text,record">
            {{ record.email }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="phonePrefix"
          title="区号"
          width="180">
          <template slot-scope="text,record">
            {{record.phonePrefix }}
          </template>
        </a-table-column>
        <a-table-column
          data-index="phone"
          :title="$t('TELEPHONE') || '手机'"
          width="180">
          <template slot-scope="text,record">
            {{record.phone ? record.phone : '-'}}
          </template>
        </a-table-column>
        <a-table-column
          data-index="birthday"
          title="生日"
          width="180">
          <template slot-scope="text,record">
            <time-formatter :time="record.birthday" format="YYYY-MM-DD"/>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="viewUser(record.id)">详细
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import {
  _queryUsers,
} from '@/api/websiteUserApi';
import TimeFormatter from '@/components/TimeFormatter.vue';

function searchUser() {
  this.table.pagination.page = 1;
  this.getUserList();
}

async function getUserList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryUsers({
    grade: this.searchForm.data.grade,
    phone: this.searchForm.data.phone,
    userId: this.searchForm.data.userId,
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

function addUser() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editUser(userId) {
  this.form.data.id = userId;
  this.form.visible = true;
}

function viewUser(userId) {
  this.$router.push(`/website-user/${userId}`);
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getUserList();
}

function handleSizeChange(val) {
  this.table.query.size = val;
  this.getUserList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getUserList();
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: sorter.field,
    order: sorter.order,
  };
  this.getUserList();
}

export default {
  name: 'WebsiteUserList',
  components: {
    TimeFormatter,
  },

  data() {
    return {
      searchForm: {
        data: {
          firstName: '',
          lastName: '',
          phone: '',
          userId: '',
          gender: '',
          email: '',
          birthday: '',
          phonePrefix: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getUserList,
    editUser,
    addUser,
    closeForm,
    viewUser,
    handlePageChange,
    handleSizeChange,
    searchUser,
    handleTableChange,
  },
  created() {
    this.getUserList();
  },
};
</script>

<style scoped>

</style>
